import type { Content } from '@ilteducation/content-registry-types';
import type { BasicCollection } from '@ilteducation/content-collections-types';

export type AggregatedContentCollection = BasicCollection & {
  groupByOriginal?: boolean;
  isRelatedContentCollection?: boolean;
};

export type ContentWithDuplicates = Content & {
  duplicatesCount?: number;
};

export const groupContentByOriginalTitle = (
  contents: Content[],
  sortCallback?: (a: Content, b: Content) => number,
): ContentWithDuplicates[] => {
  const booksByOriginalTitle: { [key: string]: Content[] } = {};

  if (sortCallback) {
    contents.sort(sortCallback);
  }
  return contents
    .filter((content: Content) => {
      if (!('originalTitle' in content)) {
        return [];
      }
      if (content.originalTitle) {
        const isFirstWithThisOriginalTitle = !booksByOriginalTitle[content.originalTitle];

        booksByOriginalTitle[content.originalTitle] = [...(booksByOriginalTitle[content.originalTitle] || []), content];

        return isFirstWithThisOriginalTitle;
      }
      return true;
    })
    .map((content: Content) => {
      if (!('originalTitle' in content)) {
        return {
          ...content,
          duplicatesCount: 0,
        };
      }
      return {
        ...content,
        duplicatesCount: booksByOriginalTitle[content.originalTitle!]?.length || 0,
      };
    });
};

export const hasDuplicates = (book: Content): book is ContentWithDuplicates =>
  (book as ContentWithDuplicates).duplicatesCount !== undefined;
